import { CognitoUserPool } from 'amazon-cognito-identity-js';

export default (userPoolId: any, clientId: any) => {
    const poolData = {
        UserPoolId: userPoolId,
        ClientId: clientId,
    };
    return new CognitoUserPool(poolData);
};
